import React from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './TopBar.module.css';
import Logo from '../../../../../Assets/images/fn_logo.png';
import { ActionButton, SecondaryButton } from '../../Buttons/Buttons';
import { displayApprovalBadge } from '../../../../VendorApplicationOnboarding/StepsSelector';
import { StatusPanelModal } from './StatusPanelModal';
import ReviewApplicationModal from './ReviewApplicationModal';

function TopBar({
  buttonText = null,
  onClickButton = () => {},
  editMode = true,
  currentUser = null,
  approvalMode = false,
  currentApplication = null,
  onApprove = () => {},
}) {
  const [openApprovalModal, setOpenApprovalModal] = React.useState(false);
  const [confirmationText, setConfirmationText] = React.useState('');
  const { status } = currentApplication || {};

  const handleApproveConfirmation = (approvalStatus) => {
    setConfirmationText(approvalStatus);
    setOpenApprovalModal(true);
  };

  const handleCancelApproval = () => {
    setConfirmationText('');
    setOpenApprovalModal(false);
  };

  // todo: Extract specific logic related to the vendor onboarding process to a separate component

  return (
    <div className={styles.topBar}>
      <div className={styles.iconLogoContainer}>
        {currentUser && currentUser.role === 'VENDOR' ? (
          <div className={styles.logoLink}>
            <img src={Logo} alt="" className={styles.logo} />
          </div>
        ) : (
          <Link to="/vendor-applications" className={styles.logoLink}>
            <ArrowBackIosIcon fontSize="small" />
            <img src={Logo} alt="" className={styles.logo} />
          </Link>
        )}
      </div>
      <div className={styles.displayFlex}>
        {buttonText && (
          <ActionButton onClick={onClickButton} disabled={editMode}>
            {buttonText}
          </ActionButton>
        )}
        {currentUser &&
          currentUser.role !== 'VENDOR' &&
          currentApplication.metadata && (
            <StatusPanelModal
              status={status}
              currentApplication={currentApplication}
              onApprove={onApprove}
              onCancelApprove={handleCancelApproval}
              userRole={currentUser.role}
            />
          )}
        <span className={styles.itemCentered}>
          {currentUser &&
            displayApprovalBadge(currentUser.role, status, currentUser.title)}
        </span>
        {approvalMode && !currentApplication.application_archived_at && (
          <>
            <div className={styles.approvalMode}>
              <ActionButton
                onClick={() => handleApproveConfirmation('deny')}
                destructive
              >
                Deny
              </ActionButton>
              <SecondaryButton
                onClick={() => handleApproveConfirmation('approve')}
              >
                Approve
              </SecondaryButton>
            </div>

            <ReviewApplicationModal
              open={openApprovalModal}
              onClose={() => setOpenApprovalModal(false)}
              confirmationText={confirmationText}
              status={status}
              currentApplication={currentApplication}
              onApprove={onApprove}
              onCancelApprove={handleCancelApproval}
            />
          </>
        )}
      </div>
    </div>
  );
}

TopBar.propTypes = {
  buttonText: PropTypes.string,
  onClickButton: PropTypes.func,
  currentUser: PropTypes.shape({
    role: PropTypes.string,
  }),
  editMode: PropTypes.bool,
  approvalMode: PropTypes.bool,
  currentApplication: PropTypes.shape({
    id: PropTypes.string,
    company_name: PropTypes.string,
  }),
  onApprove: PropTypes.func,
};

export default TopBar;
